/**
 * PrivacyBaseSection Component
 * 
 * Re-exports the shared LegalBaseSection for backward compatibility.
 */
import LegalBaseSection from "../common/LegalBaseSection";

export default LegalBaseSection; 